(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bluebird"), require("fs"), require("child_process"), require("crypto"), require("os"), require("path"), require("regenerator-runtime"));
	else if(typeof define === 'function' && define.amd)
		define(["bluebird", "fs", "child_process", "crypto", "os", "path", "regenerator-runtime"], factory);
	else if(typeof exports === 'object')
		exports["electron-sudo"] = factory(require("bluebird"), require("fs"), require("child_process"), require("crypto"), require("os"), require("path"), require("regenerator-runtime"));
	else
		root["electron-sudo"] = factory(root["bluebird"], root["fs"], root["child_process"], root["crypto"], root["os"], root["path"], root["regenerator-runtime"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_59__, __WEBPACK_EXTERNAL_MODULE_60__, __WEBPACK_EXTERNAL_MODULE_119__, __WEBPACK_EXTERNAL_MODULE_120__, __WEBPACK_EXTERNAL_MODULE_121__, __WEBPACK_EXTERNAL_MODULE_122__, __WEBPACK_EXTERNAL_MODULE_123__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition